import { isEmptyStringOrNull } from '@/shared/utils/misc';
import { charityRegisterLinkProps } from '@/shared/utils/url';

import { getControl, getEditor, getProps } from '@/front/editable/state';
import { listen } from '@/front/event';
import { getEditableDiv, setVisible } from '@/front/utils/dom';

const getEditableValue = (id?: string): string | null | undefined => {
  if (!id) return;

  const value = getControl(id)?.value ?? getEditor(id)?.value;
  return typeof value === 'string' || value == null ? value : undefined;
};

const onEditableChange = (editable: HTMLElement | null, refresh: () => void) => {
  if (!editable) return;

  const editor = getEditor(editable.id);
  if (editor) {
    editor.addEventListener('actionSuccess', refresh);
    return;
  }

  getControl(editable.id)?.addEventListener('change', refresh);
};

export const refreshCharityNumberLink = (charityNumberEditable: HTMLElement) => {
  const props = getProps(charityNumberEditable.id);
  if (!props) return;

  const form = charityNumberEditable.closest('form');
  if (!form) return;

  const organisationType = getEditableDiv(form, 'organisationType');
  const registrationNumber = getEditableDiv(form, 'registrationNumber');
  const charityNumber = getEditableValue(charityNumberEditable.id);

  const linkProps = charityRegisterLinkProps(
    getEditableValue(organisationType?.id),
    getEditableValue(registrationNumber?.id),
    charityNumber,
  );

  const urlButton = (charityNumberEditable.closest('.editable-wrapper') ?? charityNumberEditable).querySelector(
    '[data-url-button]',
  ) as HTMLAnchorElement | null;

  const showLink = !isEmptyStringOrNull(charityNumber) && !!linkProps;

  if (linkProps) {
    props.urlTemplate = linkProps.urlTemplate;
    props.urlLabel = linkProps.urlLabel;

    const labelSpan = urlButton?.querySelector('span');
    if (labelSpan) {
      labelSpan.textContent = linkProps.urlLabel;
    }
  }

  setVisible(urlButton, showLink);
};

listen('editablesReady', () => {
  [...document.querySelectorAll('.editable[data-field="charityNumber"]')]
    .map((editable) => editable as HTMLDivElement)
    .forEach((editable) => {
      const form = editable.closest('form') as HTMLFormElement | null;
      if (!form) return;

      const refresh = () => refreshCharityNumberLink(editable);

      refresh();
      onEditableChange(editable, refresh);
      onEditableChange(getEditableDiv(form, 'registrationNumber'), refresh);
    });
});
